import { useQuery } from '@tanstack/react-query';
import subscriptionsService from 'v2/services/subscriptions';

import type { SubscriptionPlan } from 'v2/interfaces/subscriptions';

import type { UseQueryOptions } from '@tanstack/react-query';

export function useGetSubscriptionPlan(planId: number, options: UseQueryOptions<SubscriptionPlan> = {}) {
  return useQuery({
    queryKey: ['product', 'plans', planId],
    queryFn: () => subscriptionsService.getSubscriptionPlan(planId),
    ...options,
  });
}
